import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type LoanRequestStep = "loanInfo" | "invoice";

interface IStoreInfo {
    StoreCode: string;
    StoreName: string;
    ServiceType: string;
    StoreOwner: string;
}

interface ILoanInfo {
    LoanPlan: string;
    LoanAmount: string;
    LoanRate: string;
    InstallmentCount: string;
    ProductName: string;
    SubscriptionFee: string;
    InquiryFee: string;
}

interface ILoanRequest {
    step: LoanRequestStep;
    StoreInfo: IStoreInfo;
    LoanInfo: ILoanInfo;
    acceptTerms: boolean;
}

const initialState: ILoanRequest = {
    step: "loanInfo",
    StoreInfo: {
        StoreCode: "",
        StoreName: "",
        ServiceType: "",
        StoreOwner: ""
    },
    LoanInfo: {
        LoanPlan: "",
        LoanAmount: "",
        LoanRate: "",
        InstallmentCount: "",
        ProductName: "",
        SubscriptionFee: "",
        InquiryFee: ""
    },
    acceptTerms: false
}

const LoanRequestSlice = createSlice({
    name: "LoanRequest",
    initialState,
    reducers: {
        setStep: (state, action: PayloadAction<LoanRequestStep>) => {
            state.step = action.payload;
        },
        setStoreInfo: (state, action: PayloadAction<Partial<IStoreInfo>>) => {
            state.StoreInfo = { ...state.StoreInfo, ...action.payload };
        },
        setLoanInfo: (state, action: PayloadAction<Partial<ILoanInfo>>) => {
            state.LoanInfo = { ...state.LoanInfo, ...action.payload };
        },
        setAcceptTerms: (state, action: PayloadAction<boolean>) => {
            state.acceptTerms = action.payload;
        },
        resetLoanRequestForm: () => initialState
    }
})

export const {
    setStep,
    setStoreInfo,
    setLoanInfo,
    setAcceptTerms,
    resetLoanRequestForm
} = LoanRequestSlice.actions;

export default LoanRequestSlice.reducer;